module.exports = __webpack_public_path__ + "img/5.019905f6.jpg";